/**
return string value without spacebar or space

@param input - String

*/
export default value => {
  return value.replace(/\s/g, "");
};
